import DealerCollection from '@/models/dealer-collection.model';
import { AxiosResponse } from 'axios';

interface DealerCacheEntry {
    key: string;
    value: Promise<AxiosResponse<DealerCollection>>;
}

export default class ApiCache {
    private maxSize: number;
    private entries: Array<DealerCacheEntry>;

    constructor(maxSize = 10) {
        this.maxSize = maxSize;
        this.entries = [];
    }

    has(key: string): boolean {
        return this.entries.some(entry => entry.key === key);
    }

    get(key: string): Promise<AxiosResponse<DealerCollection>> | null {
        for (let i = 0, iLen = this.entries.length; i < iLen; i++) {
            const entry = this.entries[i];

            if (entry.key === key) {
                return entry.value;
            }
        }

        return null;
    }

    set(key: string, value: Promise<AxiosResponse<DealerCollection>>) {
        this.entries.push({
            key,
            value
        });

        if (this.entries.length > this.maxSize) {
            // if max cache size is reached
            // remove the first cache entry
            this.entries.shift();
        }
    }
}